import { FormatNumber } from '../../../../../_config/utils/format-number.util';
import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import { isDateInRange } from '../../../../../v2-config/utils/is-date-in-range.util';

export const handlePromotionPrice = (product, className) => {
	if (product.promotions === null) {
		return <h3 className={'promotion-none'}> </h3>;
	}
	if (!isDateInRange(product?.promotions?.date_start, product?.promotions?.date_end)) {
		return <h3 className={'promotion-none'}> </h3>;
	}
	return <h3 className={className}>{FormatNumber[Enviroment.COUNTRY].handleFormat(product.price)}</h3>;
};
